import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';

import useMapLocation from './hooks/useMapLocation';
import MapSizeContext from './MapSizeContext';

export interface ISimplePointProps {
  point: any;
  selected: boolean;
  visible: boolean;
  monitor: string;
  fullFormat: boolean;
  Longitute: string;
  Latitude: string;
  wpn: string;
  WPN: string;
  isPrimaryHooked: boolean;
  isSecondaryHooked: boolean;
  fillingColor?: string;
}

interface Position {
  x?: number;
  y?: number;
}

const Container = styled.div<Position>`
  position: absolute;
  left: 0;
  top: 0;
`;
export default function SimplePoint(props: ISimplePointProps) {
  const {
    point,
    monitor,
    selected,
    fullFormat,
    Longitute,
    Latitude,
    wpn,
    WPN,
    fillingColor,
  } = props;

  const [position, setPosition] = useState({
    x: 0,
    y: 0,
  });
  const sizes = useContext(MapSizeContext);
  const { latLangToXY, rerender } = useMapLocation(monitor, sizes);

  useEffect(() => {
    if (fullFormat) {
      const [translatedX, translatedY] = latLangToXY(Longitute, Latitude);
      setPosition({
        x: translatedX,
        y: translatedY,
      });
    } else if (point) {
      const latitude = `${point.latV} ${point.latH}`;
      const longitude = `${point.longV} ${point.longH}`;

      const [translatedX, translatedY] = latLangToXY(longitude, latitude);

      setPosition({
        x: translatedX,
        y: translatedY,
      });
    }
  }, [point, rerender]);
  return (
    <>
      <circle
        cx={position.x}
        cy={position.y}
        r={4}
        // stroke={'black'}
        strokeWidth="1"
        fill={fillingColor || 'yellow'}
        fill-opacity="1"
      ></circle>
    </>
  );
}
